var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { VueType, Component } from '../core';
import { ICollectState } from '../../store/CollectState';
import CollectItem from './CollectItem';
import RecChannel from '../common/rec/RecChannel';
let CollectList = class CollectList extends VueType {
    get renderList() {
        const { activeTab } = this.state;
        return activeTab.followList;
    }
    get tabTitle() {
        return this.state.activeTab.name;
    }
    render() {
        var _a;
        if ((_a = this.renderList) === null || _a === void 0 ? void 0 : _a.length) {
            return <div class="collect_list">
                {this.renderList.map(item => <CollectItem data={item} tabTitle={this.tabTitle} key={item.attentKey}></CollectItem>)}
            </div>;
        }
        return <RecChannel title="你还没有任何收藏记录,不如试试这些专属推荐"></RecChannel>;
    }
};
__decorate([
    ICollectState
], CollectList.prototype, "state", void 0);
CollectList = __decorate([
    Component
], CollectList);
export default CollectList;
